import { Tag as AntdTag, TagProps } from 'antd';

function Tag(props: TagProps) {
  return <AntdTag bordered={false} {...props} />;
}

export default Tag;
